module.exports = __webpack_public_path__ + "img/電気回路_6_4_3.7706e9c0.png";